import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e91362ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vacancy-catalog" }
const _hoisted_2 = {
  key: 0,
  class: "vacancy-catalog__loading"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "i-preloader is-active" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "i-preloader__item" })
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "vacancy-catalog__wrapper" }
const _hoisted_6 = { class: "ds-panel ds-panel--space_sm" }
const _hoisted_7 = { class: "ds-panel__element ds-panel__element--offset_bottom" }
const _hoisted_8 = { class: "ds-caption ds-caption--size_3md ds-caption--size_4md-sm ds-caption--size_lg-md ds-caption--size_xl-lg ds-caption--size_3xl-xl ds-caption--weight_semi-bold ds-caption--color_dark ds-caption--ff_bahnschrift vacancy-catalog__title" }
const _hoisted_9 = {
  key: 0,
  class: "vacancy-catalog__banner"
}
const _hoisted_10 = {
  key: 1,
  class: "vacancy-catalog__banner-img"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "vacancy-catalog__wrapper" }
const _hoisted_14 = { class: "ds-panel ds-panel--space_xl" }
const _hoisted_15 = { class: "ds-panel__element ds-panel__element--offset_bottom" }
const _hoisted_16 = { class: "ds-caption ds-caption--size_2xl ds-caption--size_3xl-lg ds-caption--weight_semi-bold ds-caption--ff_bahnschrift vacancy-catalog__title" }
const _hoisted_17 = {
  key: 0,
  class: "vacancy-catalog__grid"
}
const _hoisted_18 = {
  key: 1,
  class: "vacancy-catalog__empty"
}
const _hoisted_19 = { class: "ds-caption ds-caption--size_sm ds-caption--color_relief-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_video = _resolveComponent("ui-video")!
  const _component_vacancy_card = _resolveComponent("vacancy-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.$t('Вакансії')), 1)
              ])
            ]),
            ($setup.validVideoUrl || $setup.bannerSrc)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  ($setup.validVideoUrl)
                    ? (_openBlock(), _createBlock(_component_ui_video, {
                        key: 0,
                        url: $setup.validVideoUrl
                      }, null, 8, ["url"]))
                    : (_openBlock(), _createElementBlock("picture", _hoisted_10, [
                        _createElementVNode("img", {
                          src: $setup.bannerSrc,
                          alt: "",
                          loading: "lazy"
                        }, null, 8, _hoisted_11)
                      ]))
                ]))
              : _createCommentVNode("", true),
            ($setup.settings?.companyDescription)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "vacancy-catalog__description t-content",
                  innerHTML: $setup.settings.companyDescription
                }, null, 8, _hoisted_12))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("h2", _hoisted_16, _toDisplayString(_ctx.$t('Хто нам потрібен?')), 1)
              ])
            ]),
            ($setup.vacancyList?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.vacancyList, (item) => {
                    return (_openBlock(), _createBlock(_component_vacancy_card, {
                      key: item.id,
                      item: item
                    }, null, 8, ["item"]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t('Наразі немає відкритих вакансій')), 1)
                ]))
          ])
        ], 64))
  ]))
}